<template>
  <div :class="[$style.wrapper, 'app-navbar']" role="navigation">
    <button
      :class="[
        $style.item,
        $style.iconMarket,
        isActive('/market') && $style.active,
      ]"
    >
      <router-link to="/market">
        <span :class="$style.iconBox">
          <img src="@/assets/img/navbar/market.svg" alt="market" />
        </span>
        <p>Маркет</p>
      </router-link>
    </button>

    <button
      :class="[
        $style.item,
        $style.iconDeals,
        isActive('/deals') && $style.active,
        isDealsDisabled && $style.disabled,
      ]"
      :disabled="isDealsDisabled"
    >
      <router-link to="/deals" @click.prevent="handleDealsClick">
        <span :class="$style.iconBox">
          <img src="@/assets/img/navbar/deals.svg" alt="deals" />
        </span>
        <p>Сделки</p>
      </router-link>
    </button>

    <button
      :class="[
        $style.item,
        $style.iconFavorites,
        isActive('/favorites') && $style.active,
      ]"
    >
      <router-link to="/favorites">
        <span :class="$style.iconBox">
          <img src="@/assets/img/navbar/favorites.svg" alt="favorites" />
        </span>
        <p>Избранное</p>
      </router-link>
    </button>

    <button
      :class="[$style.item, $style.iconAccount, isActive('/') && $style.active]"
    >
      <router-link to="/">
        <span :class="$style.iconWrap">
          <span :class="$style.iconBox">
            <img src="@/assets/img/navbar/account.svg" alt="account" />
          </span>
          <span v-if="notificationsCount > 0" :class="$style.badge">
            {{ notificationsCount }}
          </span>
        </span>
        <p>Кабинет</p>
      </router-link>
    </button>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  computed: {
    user() {
      return this.$store.state.user || {}
    },
    notificationsCount() {
      return this.$store.state.notificationsCount ?? 0
    },
    isDealsDisabled() {
      return this.user.moderation_status === "pending"
    },
  },
  methods: {
    isActive(path) {
      if (path === "/") {
        // Подсвечиваем "Кабинет" для маршрутов /, /docs, /faq, /notifications и других страниц кабинета
        return (
          this.$route.path === "/" ||
          this.$route.path.startsWith("/docs") ||
          this.$route.path === "/faq" ||
          this.$route.path === "/notifications" ||
          this.$route.path.startsWith("/personal-info") ||
          this.$route.path.startsWith("/my-products") ||
          this.$route.path.startsWith("/add-product") ||
          this.$route.path.startsWith("/edit-product") ||
          this.$route.path.startsWith("/upload-excel") ||
          this.$route.path.startsWith("/select-model")
        )
      }
      if (path === "/market") {
        // Подсвечиваем "Маркет" для маршрутов /market, /model/*, /brand/* и /seller/*
        return (
          this.$route.path.startsWith("/market") ||
          this.$route.path.startsWith("/model") ||
          this.$route.path.startsWith("/brand") ||
          this.$route.path.startsWith("/seller")
        )
      }
      return this.$route.path.startsWith(path)
    },
    handleDealsClick(event) {
      if (this.isDealsDisabled) {
        event.preventDefault()
        return false
      }
      this.$router.push("/deals")
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: 3.125rem;
  padding: 0.5rem 0 calc(1.5rem + env(safe-area-inset-bottom)) 0;
  background: #ffffff;
  border-top: 1px solid #ebeaea;
  z-index: 10;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;

  a {
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .iconBox img {
    filter: grayscale(1) opacity(0.65);
  }

  p {
    font-size: 0.625rem;
    font-weight: 500;
    color: rgba(84, 84, 88, 0.65);
  }
}

.iconWrap {
  position: relative;
  display: inline-flex;
}

.badge {
  position: absolute;
  top: -0.35rem;
  right: -0.75rem;
  min-width: 1.125rem;
  height: 1.125rem;
  padding: 0.125rem;
  border-radius: 999px;
  font-weight: 700;
  color: black;
  font-size: 0.75rem;
  line-height: calc(1.125rem - 4px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.iconBox {
  position: relative;
  display: inline-block;
  width: 1.625rem;
  height: 1.625rem;
  margin: 0 0 0.125rem 0;

  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.active {
  p {
    color: #ec6608;
  }
  .iconBox img {
    opacity: 0;
  }
  .iconBox::before {
    content: "";
    position: absolute;
    inset: 0;
    background-color: #ec6608;
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
  }
}

.iconMarket.active .iconBox::before {
  -webkit-mask-image: url("@/assets/img/navbar/market.svg");
  mask-image: url("@/assets/img/navbar/market.svg");
}

.iconDeals.active .iconBox::before {
  -webkit-mask-image: url("@/assets/img/navbar/deals.svg");
  mask-image: url("@/assets/img/navbar/deals.svg");
}

.iconFavorites.active .iconBox::before {
  -webkit-mask-image: url("@/assets/img/navbar/favorites.svg");
  mask-image: url("@/assets/img/navbar/favorites.svg");
}

.iconAccount.active .iconBox::before {
  -webkit-mask-image: url("@/assets/img/navbar/account.svg");
  mask-image: url("@/assets/img/navbar/account.svg");
}

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;

  a {
    pointer-events: none;
  }
}
</style>
